import { render, staticRenderFns } from "./SaveForm.vue?vue&type=template&id=1f1ece8c&"
import script from "./SaveForm.vue?vue&type=script&lang=js&"
export * from "./SaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports